"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceView = exports.PriceViewString = void 0;
const react_1 = __importDefault(require("react"));
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
const PriceViewString = (price, displayPriceFromLabel) => `<div>
    ${displayPriceFromLabel ? '<span class ="price-from-label">od</span>' : ''}
    <span class ="withoutVat">${NumberFormatter_1.default.formatPrice(price.withoutVat)}</span>
    <span class ="withVat">${NumberFormatter_1.default.formatPrice(price.withVat)}</span>
</div>`;
exports.PriceViewString = PriceViewString;
const PriceView = (price, displayPriceFromLabel = true) => react_1.default.createElement("div", { dangerouslySetInnerHTML: {
        __html: (0, exports.PriceViewString)(price, displayPriceFromLabel),
    } });
exports.PriceView = PriceView;
